module.exports = __webpack_public_path__ + "img/pen.9d633dad.svg";